import { EmployerSettingsResponse } from 'RestAPIs/employer-settings';

import { CalculatedHours } from './GrossNetHoursCalculation';

export const getCalculatedHoursFromNPH = (
  settings: EmployerSettingsResponse
) => {
  const types = Object.keys(settings.nphPercentage);
  const totals = {
    netPerFTE: 0
  };

  types.forEach((type) => {
    const calculationPercentage =
      settings.nphPercentageSubstitute[type] ?? settings.nphPercentage[type];
    totals[type] = settings.yearHours * calculationPercentage;
  });

  totals.netPerFTE =
    settings.yearHours -
    types.reduce((acc, next) => {
      acc += totals[next];
      return acc;
    }, 0);

  return totals as CalculatedHours;
};
